"use client";

import { Heart, Users, Utensils } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeartOfOurHome() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="heart-of-our-home" className="relative w-full min-h-[80vh] flex items-center justify-center py-24 overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586469/img/family_dining_table_warm.png')] bg-cover bg-center blur-md scale-110 transform transition-transform duration-1000" />
        {}
        <div className="absolute inset-0 bg-foreground/10 dark:bg-background/60" />
      </div>

      {}
      <div className="container relative z-10 px-4 md:px-6">
        <div ref={ref} className={`max-w-4xl mx-auto transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Card className="bg-background/95 backdrop-blur-xl border-border/40 shadow-2xl overflow-hidden rounded-3xl">
            <CardHeader className="text-center pb-4 pt-12 md:pt-16 px-6 md:px-16">
              <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-secondary/15 text-secondary ring-8 ring-secondary/5">
                <Heart className="h-8 w-8" />
              </div>
              <CardTitle className="font-serif text-4xl md:text-5xl lg:text-6xl text-foreground tracking-tight mb-4">
                Personalized Assisted Living in Silver Spring, Maryland
              </CardTitle>
              <CardDescription className="text-lg md:text-xl text-muted-foreground font-medium max-w-2xl mx-auto">A warm, family-like assisted living home offering personalized care in a small residential setting.</CardDescription>
            </CardHeader>
            
            <CardContent className="px-6 md:px-16 pb-12 md:pb-16 text-center">
              <p className="text-base md:text-lg text-foreground/80 leading-relaxed mb-10 max-w-3xl mx-auto">Family First Senior Care is a boutique residential assisted living home in Montgomery County, serving up to 5 residents in Silver Spring, Maryland. Our home provides 24/7 caregiver support, home-cooked meals, and a safe, comfortable environment where every resident receives personal attention and compassionate care.</p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 text-left max-w-3xl mx-auto">
                <div className="flex items-start gap-5 p-6 rounded-2xl bg-accent/40 border border-accent/50 transition-colors hover:bg-accent/60">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-background shadow-sm">
                    <Utensils className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-foreground text-lg mb-1">Home-Cooked Meals</h4>
                    <p className="text-sm text-muted-foreground leading-relaxed">Nutritious meals prepared fresh daily and tailored to each resident’s dietary needs.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-5 p-6 rounded-2xl bg-accent/40 border border-accent/50 transition-colors hover:bg-accent/60">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-background shadow-sm">
                    <Users className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-foreground text-lg mb-1">Intimate Community</h4>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      With a limit of just 5 residents, we provide a level of personalized attention and companionship that only a small home can offer.
                    </p>
                  </div>
                </div>
              </div>

              <Button asChild size="lg" className="rounded-full px-8 h-12 text-base shadow-md hover:shadow-lg transition-all">
                <Link to="/AboutUsPage">
                  Explore Our Family-Like Care
                </Link>
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}